import { Action, createReducer, on } from '@ngrx/store';
import { IPFSettingsPreviousFileResponse } from '../models/pf-settings-file.model';
import * as actions from '../actions';

export const getPFSettingsPreviousFileFeatureKey = 'getPFSettingsPreviousFile';
export interface PFSettingsPreviousFileState {
  loadPFSettingsPreviousFileResponse: IPFSettingsPreviousFileResponse[];
  loadPFSettingsPreviousFileResponseFailure: any;
  loaded: boolean;
}

export const initialState: PFSettingsPreviousFileState = {
  loadPFSettingsPreviousFileResponse: undefined,
  loadPFSettingsPreviousFileResponseFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPFSettingsPreviousFiles, (state, action) => ({
    ...state
  })),
  on(actions.loadPFSettingsPreviousFilesSuccess, (state, action) => ({
    ...state,
    loadPFSettingsPreviousFileResponse: action.response,
    loaded: true
  })),
  on(actions.loadPFSettingsPreviousFilesFailure, (state, action) => ({
    ...state,
    loadPFSettingsPreviousFileResponseFailure: action.error
  }))
);

export const getPFSettingsPreviousFileResponse = (state: PFSettingsPreviousFileState) => {
  if (state && state.loadPFSettingsPreviousFileResponse) return JSON.parse(JSON.stringify(state.loadPFSettingsPreviousFileResponse));
  else return null;
};

export const getPFSettingsPreviousFileIsLoaded = (state: PFSettingsPreviousFileState) => {
  state.loaded;
};
